import { IconButton } from "components/IconButton"
import { Link } from "theme-ui"
import { LogoSlack } from "icons/LogoSlack"
import { Tooltip } from "components/Tooltip"
import React from "react"

interface SlackButtonProps {
  channelId: string
  className?: string
  teamId: string
}

export const SlackButton: React.FC<SlackButtonProps> = ({
  channelId,
  className,
  teamId,
}) => {
  return (
    <Tooltip content="Open in Slack" className={className}>
      <Link
        href={`https://${teamId}.slack.com/messages/#${channelId}/`}
        target="_blank"
      >
        <IconButton>
          <LogoSlack width={18} height={18} />
        </IconButton>
      </Link>
    </Tooltip>
  )
}
